export default {
  pt: {
    'export.baixar': 'Baixar Excel',
    'export.gerando': 'Gerando planilha',
    'export.pronto': 'Planilha baixada.',
  },
  en: {
    'export.baixar': 'Download Excel',
    'export.gerando': 'Building the spreadsheet',
    'export.pronto': 'Spreadsheet downloaded.',
  },
  es: {
    'export.baixar': 'Descargar Excel',
    'export.gerando': 'Generando la planilla',
    'export.pronto': 'Planilla descargada.',
  },
}
